"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketplaceId = exports.SiteId = void 0;
var SiteId;
(function (SiteId) {
    SiteId[SiteId["EBAY_US"] = 0] = "EBAY_US";
    SiteId[SiteId["EBAY_ENCA"] = 2] = "EBAY_ENCA";
    SiteId[SiteId["EBAY_GB"] = 3] = "EBAY_GB";
    SiteId[SiteId["EBAY_AU"] = 15] = "EBAY_AU";
    SiteId[SiteId["EBAY_AT"] = 16] = "EBAY_AT";
    SiteId[SiteId["EBAY_FRBE"] = 23] = "EBAY_FRBE";
    SiteId[SiteId["EBAY_FR"] = 71] = "EBAY_FR";
    SiteId[SiteId["EBAY_DE"] = 77] = "EBAY_DE";
    SiteId[SiteId["EBAY_MOTOR"] = 100] = "EBAY_MOTOR";
    SiteId[SiteId["EBAY_IT"] = 101] = "EBAY_IT";
    SiteId[SiteId["EBAY_NLBE"] = 123] = "EBAY_NLBE";
    SiteId[SiteId["EBAY_NL"] = 146] = "EBAY_NL";
    SiteId[SiteId["EBAY_ES"] = 186] = "EBAY_ES";
    SiteId[SiteId["EBAY_CH"] = 193] = "EBAY_CH";
    SiteId[SiteId["EBAY_HK"] = 201] = "EBAY_HK";
    SiteId[SiteId["EBAY_IN"] = 203] = "EBAY_IN";
    SiteId[SiteId["EBAY_IE"] = 205] = "EBAY_IE";
    SiteId[SiteId["EBAY_MY"] = 207] = "EBAY_MY";
    SiteId[SiteId["EBAY_FRCA"] = 210] = "EBAY_FRCA";
    SiteId[SiteId["EBAY_PH"] = 211] = "EBAY_PH";
    SiteId[SiteId["EBAY_PL"] = 212] = "EBAY_PL";
    SiteId[SiteId["EBAY_SG"] = 216] = "EBAY_SG";
})(SiteId = exports.SiteId || (exports.SiteId = {}));
var MarketplaceId;
(function (MarketplaceId) {
    MarketplaceId["EBAY_US"] = "EBAY_US";
    MarketplaceId["EBAY_AT"] = "EBAY_AT";
    MarketplaceId["EBAY_AU"] = "EBAY_AU";
    MarketplaceId["EBAY_BE"] = "EBAY_BE";
    MarketplaceId["EBAY_CA"] = "EBAY_CA";
    MarketplaceId["EBAY_CH"] = "EBAY_CH";
    MarketplaceId["EBAY_DE"] = "EBAY_DE";
    MarketplaceId["EBAY_ES"] = "EBAY_ES";
    MarketplaceId["EBAY_FR"] = "EBAY_FR";
    MarketplaceId["EBAY_GB"] = "EBAY_GB";
    MarketplaceId["EBAY_HK"] = "EBAY_HK";
    MarketplaceId["EBAY_IE"] = "EBAY_IE";
    MarketplaceId["EBAY_IN"] = "EBAY_IN";
    MarketplaceId["EBAY_IT"] = "EBAY_IT";
    MarketplaceId["EBAY_MY"] = "EBAY_MY";
    MarketplaceId["EBAY_NL"] = "EBAY_NL";
    MarketplaceId["EBAY_PH"] = "EBAY_PH";
    MarketplaceId["EBAY_PL"] = "EBAY_PL";
    MarketplaceId["EBAY_SG"] = "EBAY_SG";
    MarketplaceId["EBAY_TH"] = "EBAY_TH";
    MarketplaceId["EBAY_TW"] = "EBAY_TW";
    MarketplaceId["EBAY_VN"] = "EBAY_VN";
    MarketplaceId["EBAY_MOTORS_US"] = "EBAY_MOTORS_US";
})(MarketplaceId = exports.MarketplaceId || (exports.MarketplaceId = {}));
//# sourceMappingURL=apiEnums.js.map